<template>
  <div style="padding-bottom: 5px">
    <span style="width: 40%; display: inline-block">{{ stock[1] }}</span>
    <a
      href="javascript:void(0);"
      class="btn btn-default btn-xs btn-none-radius"
      style="padding: 4px 5px 1px 5px; font-size: 10px"
      @click="removeCount()"
      :disabled="stock[2] == this.min"
    >
      <span class="glyphicon glyphicon-minus"></span>
    </a>
    <span
      style="
        width: 30px;
        display: inline-block;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
      "
    >
      {{ stock[2] }}</span
    >
    <a
      href="javascript:void(0);"
      class="btn btn-default btn-xs btn-none-radius"
      style="padding: 4px 5px 1px 5px; font-size: 10px"
      @click="addCount()"
      :disabled="stock[2] == this.max"
    >
      <span class="glyphicon glyphicon-plus"></span>
    </a>
  </div>
</template>

<script>
import api from '@/api'
export default {
  props: ['value', 'productId'],
  data: function () {
    return {
      stock: this.value,
      max: 1000,
      min: 0
    }
  },
  watch: {
    value: function () {
      this.stock = this.value
    }
  },
  methods: {
    removeCount: function () {
      if (this.stock[2] > this.min) {
        this.stock[2] = parseInt(this.stock[2]) - 1
        let stock = [this.stock[0], this.stock[1], this.stock[2]]
        this.updateStock()
        this.$emit('input', stock)
      }
    },
    addCount: function () {
      if (this.stock[2] < this.max) {
        this.stock[2] = parseInt(this.stock[2]) + 1
        let stock = [this.stock[0], this.stock[1], this.stock[2]]
        this.updateStock()
        this.$emit('input', stock)
      }
    },
    updateStock: function () {
      let vm = this
      let productstock = {
        id: vm.stock[0],
        option: vm.stock[1],
        productid: this.productId,
        quantity: vm.stock[2]
      }
      api.editProductStock(productstock, function (error, response) {
        if (error) {
          console.error(error)
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/event/StockItem.vue